import React from 'react'
import classNames from 'classnames'
import { faMale } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const StandingAreaLabel = (props) => {
  const {
    price,
    status,
    section,
    color,
    top,
    left,
    visible,
    showReserveButton,
    initializeReservationButtonListeners,
    tierNames,
    initializeListeners,
    seatLabelPriceText = 'Price'
  } = props

  const showPrice = seatLabelPriceText && price

  return visible ? (
    <div
      className='seatLabelContainer'
      style={{ top, left }}
      ref={initializeListeners}
    >
      <div className='seatLabelRect'>
        <div className='seatLabelHeader'>
          <FontAwesomeIcon className='seatLabelIcon' icon={faMale} />
          <span>Section Information</span>
        </div>
        <div
          className={classNames({
            'seatLabelContent seatLabelContent-large': showReserveButton,
            seatLabelContent: !showReserveButton
          })}
        >
          <div className='seatLabelRow'>
            {showPrice && (
              <div className='seatLabelItem'>
                <div className='seatLabelItemTitle'>{seatLabelPriceText}</div>
                <div className='seatLabelItemText'>{price}</div>
              </div>
            )}
            <div className='seatLabelItem'>
              <div className='seatLabelItemTitle'>Status</div>
              <div className='seatLabelItemText' style={{ color }}>
                {status}
              </div>
            </div>
          </div>
          <div className='seatLabelRow'>
            <div className={classNames('seatLabelItem', 'flex2')}>
              <div className='seatLabelItemTitle'>Section</div>
              <div className='seatLabelItemText'>
                {section + (tierNames ? ` (${tierNames})` : '')}
              </div>
            </div>
          </div>
          {showReserveButton && (
            <div className='seatLabelRow'>
              <div className='seatLabelItem'>
                <button
                  className='seatLabelButton'
                  ref={initializeReservationButtonListeners}
                >
                  Reserve
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='seatLabelTriangle' />
    </div>
  ) : null
}

export { StandingAreaLabel }
